import { Component, OnInit, Input } from '@angular/core';
import { Utility } from '../../_service/utility';
import { DnDialogService } from '../../_modules/dn-dialog/dn-dialog.service';
import { environment } from '../../../environments/environment';
import { StorageService } from 'app/storageprovider';
import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { HttpClientHelper } from 'app/_service/http-helper';
import { StickyChatService } from 'app/_modules/sticky-chat/sticky-chat.service';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {
  @Input() onlyIcon = false;
  isDark = false;
  // teleContact = {
  //   img: this.isDark ? '../assets/images/tele_dark.png' : '../assets/images/tele_light.png',
  //   link: "https://t.me/joinchat/2Q8fx90FugEyYTFk",
  //   time: "在线：13:00-21:00（GMT+1）"
  // };
  cusContact = {
    img: this.isDark ? 'assets/images/customer_dark.png' : 'assets/images/customer_light.png',
    link: "/help/contact-us",
  };
  customerServiceList;
  regionCode = 'GL';
  @Input() onlyImg = false;
  constructor(
    private dialog: DnDialogService,
    private _storage: StorageService,
    private _apiUrlHelper: ApiUrlHelper,
    private _httpClientHelper: HttpClientHelper,
    private _stickyChatService: StickyChatService,
    private _utility:Utility
  ) {
    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"]|| "1") ;
    // this.teleContact.img = this.isDark ? '../assets/images/tele_dark.png' : '../assets/images/tele_light.png';
    this.cusContact.img = this.isDark ? 'assets/images/customer_dark.png' : 'assets/images/customer_light.png';
  }

  ngOnInit() {
    try{
      this.regionCode = this._storage.GetConfig()['region'].split('.')[0];
    }
    catch(err)
    {
      
    }
    if (!this.onlyIcon) {
      this.getCustomerServiceInfo();
    }
    this._utility.GetOrCreateSubscript("theme.change").subscribe((theme) => {
      // console.log(theme)
      if (theme == "dark") {
        this.isDark = true;
      }
      else {
        this.isDark = false;
      }
      // 切换颜色后
      // this.teleContact.img = this.isDark ? '../assets/images/tele_dark.png' : '../assets/images/tele_light.png';
      this.cusContact.img = this.isDark ? 'assets/images/customer_dark.png' : 'assets/images/customer_light.png';
    });
  }
  @Input() showTitle = true;
  @Input() showTime = true;

  contact = {
    type: environment.cinema == 2 ? 1 : 0,
    list: [
      environment.cinema == 2 ? {

        name: "疑难解答",
        link: "https://bot.4paradigm.com/web/chat/10831/a1ae344d-bcee-4c71-a22e-4c9521238db7",
        time: "在线：13:00-21:00（GMT+1）"

      } : {
          name: "疑难解答",
          img: this._utility.GetHost("https://static.{Host}/images/weichat1.png?v=2"),
          time: "在线：13:00-21:00（GMT+1）"
        },
      // {
      //   name: "疑难解答",
      //   link: environment.cinema == 2 ? "https://bot.4paradigm.com/web/chat/10831/a1ae344d-bcee-4c71-a22e-4c9521238db7" : "https://bot.4paradigm.com/web/chat/10831/443af002-47dc-4e4b-94d2-d4592d63407b",
      //   time: "在线：13:00-21:00（GMT+1）"
      // }
    ]
  }

  showContact(item) {
    if (item.link) {
      // Utility.Notify("iframe.show",{
      //   link:item.link,
      //   style:{height:"103%"}
      // });
      this.dialog.open("custom-iframe-dialog", {
        size: { width: 650, height: 800 },
        url: item.link
      })
    }
  }

  getCustomerServiceInfo() {
    // 0影院, 1TGC, 2人工充值
    const api = this._apiUrlHelper.urlBuilder('customer-service-info-chat',{type: 0, region: this.regionCode});
    this._httpClientHelper.getWithCache(api).subscribe(r => {
      // console.log(r);
      if (!!r[0].list) {
        let newList;
        newList = r[0].list.map(n => {
          return {
            Title: n.title,
            // LinkURL: n.linkUrl ? n.linkUrl : Utility.GetHost() + `/user/messages/chat?avatar=${n.avatar}&name=${n.nickName}&id=${n.userKey}&temp=${n.templeType}`,
            LinkURL: n.linkUrl ? n.linkUrl : n.userKey ? this._utility.GetHost() + `/user/messages/chat?id=${n.userKey}&temp=${n.templeType}` : '',
            Image: n.icon,
            Txt: n.txt.replace(/\n/g, '<br>'),
            AccType: '',
            AccName: '',
          }
        });
        this.customerServiceList = newList;
      }
    });
  }

  hasTemp(url) {
    if (!!url) {
      return url.indexOf('temp=') !== -1 ? true : false;
    } else {
      return false;
    }
  }

  customerServiceUrl = '';
  openStickyChat(url) {
    console.log(url);
    this.customerServiceUrl = url;
    // if (!!this.getVariable('id') && !!this.getVariable('name') && !!this.getVariable('avatar') ) {
    if (!!this.getVariable('id')) {
      let partner = {
        id: this.getVariable('id'),
        // name: this.getVariable('name'),
        // avatar: this.getVariable('avatar'),
        entry: true
      };
      if (!!this.getVariable('temp')) {
        Object.assign(partner, {
          temp: this.getVariable('temp')
        });
      }
      // console.log(partner);
      this._stickyChatService.transmitPartner(partner);
    }
    this._stickyChatService.updateState(true);
    this._stickyChatService.toggleChatLog(true);
  }

  getVariable(variable) {
    if (this.customerServiceUrl.indexOf('?') !== -1) {
      let str = this.customerServiceUrl.split('?')[1];
      let vars = str.split('&');
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return(false);
    }
  }

}
